import { Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from '@core/services/settings.service';
import { Observable, of } from 'rxjs';
import { ProductEncodeSplashesViewModel } from '@models/api.models';
import { map, take } from 'rxjs/operators';
import { ActiveCampaign } from '@features/product/product.models';

@Pipe({
    name: 'campaignByMemberType',
    standalone: true
})
export class CampaignByMemberTypePipe implements PipeTransform {
    constructor(private settingsService: SettingsService) {}

    /**
     * Tries to find the first hit based on campaign ID setup in Umbraco.
     * We are using encode splashes from product settings, because this need
     * to be created a product ribbons on the top of the product card
     * Read about it in KOP-2051 | https://jira.impact.dk/browse/KOP-2051
     * @param campaigns
     * @returns Observable<ProductEncodeSplashesViewModel | null>
     */
    transform(campaigns?: ActiveCampaign[]): Observable<ProductEncodeSplashesViewModel | undefined> {
        if (!campaigns?.length) {
            return of(undefined);
        }

        return this.settingsService.settings$.pipe(
            take(1),
            map(
                ({ productSettings }) =>
                    productSettings?.encodeSplashes.find(encodeSplash =>
                        campaigns.some(
                            campaign =>
                                encodeSplash.encodeId === campaign.code || encodeSplash.encodeId === campaign.campaignId
                        )
                    )
            )
        );
    }
}
